import React, { useState } from 'react';
import { 
  AppBar, Toolbar, Typography, Button, Box, IconButton, 
  Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, 
  Container, Divider 
} from '@mui/material';
import { 
  Menu as MenuIcon, Home, Login, Close, 
  Campaign, AutoAwesome, ContactSupport, ColorLens
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isAuthenticated = false; 

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const navItems = [
    { label: 'होम', path: '/', icon: <Home fontSize="small" /> },
    { label: 'टेम्पलेट्स', path: '/templates', icon: <ColorLens fontSize="small" /> },
    { label: 'संपर्क करें', path: '/contact', icon: <ContactSupport fontSize="small" /> },
  ];

  return (
    <>
      <AppBar 
        position="fixed" 
        elevation={0}
        sx={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          borderBottom: '2px solid rgba(255, 107, 0, 0.1)', // हल्का ऑरेंज बॉर्डर
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)', // प्रीमियम सॉफ्ट शैडो
          color: '#000000',
          py: 0.5
        }}
      >
        <Container maxWidth="xl">
          <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 0, sm: 2 } }}>
            
            {/* 🌟 NEW ATTRACTIVE LOGO SECTION 🌟 */}
            <Box 
              component={Link} 
              to="/" 
              sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
            >
              {/* कलरफुल प्रचार (Megaphone) आइकॉन */}
              <Box 
                sx={{ 
                  width: 45, 
                  height: 45, 
                  mr: 1.5, 
                  borderRadius: '12px', 
                  background: 'linear-gradient(135deg, #FF512F 0%, #F09819 100%)', // ज़बरदस्त ऑरेंज-रेड ग्रेडिएंट
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  color: 'white', 
                  boxShadow: '0 4px 15px rgba(255, 81, 47, 0.4)', // आइकॉन का ग्लो इफ़ेक्ट
                  transform: 'rotate(-10deg)', // थोड़ा स्टाइलिश लुक
                  transition: 'transform 0.3s',
                  '&:hover': { transform: 'rotate(0deg) scale(1.05)' }
                }}
              >
                <Campaign sx={{ fontSize: 28 }} />
              </Box>
              
              {/* PracharApp ग्रेडिएंट टेक्स्ट */}
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: '900', 
                  letterSpacing: '-0.5px', 
                  fontFamily: '"Poppins", "Segoe UI", sans-serif',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <span style={{ color: '#1E293B' }}>Prachar</span>
                <span style={{ 
                  background: 'linear-gradient(135deg, #FF512F 0%, #F09819 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  paddingLeft: '2px'
                }}>
                  App
                </span>
              </Typography>
            </Box>

            {/* 🌟 DESKTOP NAVIGATION 🌟 */}
            <Box sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 2 }}>
              {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Button 
                    key={item.path} 
                    component={Link} 
                    to={item.path} 
                    startIcon={item.icon}
                    disableRipple
                    sx={{ 
                      color: isActive ? '#FF512F' : '#475569',
                      fontWeight: isActive ? '800' : '600',
                      fontSize: '1rem',
                      px: 2,
                      py: 1,
                      borderRadius: '12px',
                      textTransform: 'none',
                      transition: 'all 0.3s ease',
                      backgroundColor: isActive ? 'rgba(255, 81, 47, 0.08)' : 'transparent',
                      '&:hover': { 
                        color: '#FF512F', 
                        backgroundColor: 'rgba(255, 81, 47, 0.05)',
                        transform: 'translateY(-2px)'
                      }
                    }}
                  >
                    {item.label}
                  </Button>
                );
              })}
              
              <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 1, borderColor: '#CBD5E1', height: '30px', alignSelf: 'center' }} />

              {!isAuthenticated ? (
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Button 
                    component={Link} 
                    to="/login" 
                    variant="text" 
                    sx={{ 
                      color: '#1E293B', 
                      fontWeight: '800', 
                      px: 2, 
                      textTransform: 'none',
                      fontSize: '1rem',
                      '&:hover': { color: '#FF512F' }
                    }}
                  >
                    लॉगिन
                  </Button>
                  {/* शानदार कॉल-टू-एक्शन (CTA) बटन */}
                  <Button 
                    variant="contained" 
                    startIcon={<AutoAwesome />} 
                    sx={{ 
                      background: 'linear-gradient(135deg, #FF512F 0%, #F09819 100%)', 
                      color: 'white', 
                      borderRadius: '50px',
                      px: 4,
                      py: 1.2,
                      fontWeight: '800', 
                      fontSize: '1rem', 
                      textTransform: 'none',
                      boxShadow: '0 8px 20px rgba(255, 81, 47, 0.35)',
                      transition: 'all 0.3s ease',
                      '&:hover': { 
                        background: 'linear-gradient(135deg, #F09819 0%, #FF512F 100%)', 
                        boxShadow: '0 10px 25px rgba(255, 81, 47, 0.5)',
                        transform: 'translateY(-3px)'
                      } 
                    }}
                  >
                    पोस्टर बनाएं
                  </Button>
                </Box>
              ) : (
                <Button 
                  component={Link} 
                  to="/dashboard" 
                  variant="contained" 
                  sx={{ 
                    background: '#1E293B', 
                    borderRadius: '50px', 
                    fontWeight: 'bold',
                    boxShadow: '0 4px 15px rgba(30, 41, 59, 0.3)',
                    '&:hover': { background: '#0F172A' }
                  }}
                >
                  डैशबोर्ड
                </Button>
              )}
            </Box>

            {/* 🌟 MOBILE MENU ICON 🌟 */}
            <IconButton 
              color="inherit" 
              onClick={handleDrawerToggle} 
              sx={{ 
                display: { lg: 'none' }, 
                color: '#FF512F',
                background: 'rgba(255, 81, 47, 0.1)',
                borderRadius: '12px',
                '&:hover': { background: 'rgba(255, 81, 47, 0.2)' }
              }}
            >
              <MenuIcon fontSize="medium" />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* 🌟 MOBILE DRAWER 🌟 */}
      <Drawer 
        variant="temporary" 
        anchor="right" 
        open={mobileOpen} 
        onClose={handleDrawerToggle} 
        ModalProps={{ keepMounted: true }}
        PaperProps={{ sx: { width: '85%', maxWidth: 320, bgcolor: '#ffffff', borderLeft: '4px solid #FF512F' } }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          
          {/* Drawer Header */}
          <Box sx={{ p: 3, background: 'linear-gradient(to right, #ffffff, #fff7ed)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 36, height: 36, borderRadius: '10px', background: 'linear-gradient(135deg, #FF512F, #F09819)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', mr: 1.5 }}>
                <Campaign fontSize="small" />
              </Box>
              <Typography variant="h6" fontWeight="900">
                <span style={{ color: '#1E293B' }}>Prachar</span><span style={{ color: '#FF512F' }}>App</span>
              </Typography>
            </Box>
            <IconButton onClick={handleDrawerToggle} sx={{ color: '#94A3B8', bgcolor: '#F1F5F9' }} size="small">
              <Close />
            </IconButton>
          </Box>

          <List sx={{ px: 2, pt: 3 }}>
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <ListItem key={item.path} disablePadding sx={{ mb: 1.5 }}>
                  <ListItemButton 
                    component={Link} 
                    to={item.path} 
                    onClick={handleDrawerToggle}
                    sx={{ 
                      borderRadius: '12px', py: 1.5,
                      background: isActive ? 'linear-gradient(90deg, rgba(255,81,47,0.1) 0%, rgba(255,255,255,0) 100%)' : 'transparent',
                      borderLeft: isActive ? '4px solid #FF512F' : '4px solid transparent',
                      '&:hover': { bgcolor: '#F8FAFC' }
                    }}
                  >
                    <ListItemIcon sx={{ color: isActive ? '#FF512F' : '#64748b', minWidth: 45 }}>
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText 
                      primary={item.label} 
                      primaryTypographyProps={{ 
                        fontWeight: isActive ? '800' : '600',
                        fontSize: '1.1rem',
                        color: isActive ? '#FF512F' : '#334155' 
                      }} 
                    />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>

          <Box sx={{ mt: 'auto', p: 3, background: '#F8FAFC', borderTop: '1px solid #E2E8F0' }}>
            {!isAuthenticated ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Button 
                  fullWidth 
                  variant="outlined" 
                  component={Link} 
                  to="/login" 
                  onClick={handleDrawerToggle}
                  startIcon={<Login />}
                  sx={{ color: '#1E293B', borderColor: '#CBD5E1', borderRadius: '12px', py: 1.5, fontWeight: '800', bgcolor: 'white' }}
                >
                  लॉगिन करें
                </Button>
                <Button 
                  fullWidth 
                  variant="contained" 
                  startIcon={<AutoAwesome />}
                  sx={{ 
                    background: 'linear-gradient(135deg, #FF512F 0%, #F09819 100%)', 
                    color: 'white', 
                    borderRadius: '12px', 
                    py: 1.5, 
                    fontWeight: '900', 
                    fontSize: '1.1rem', 
                    boxShadow: '0 8px 20px rgba(255, 81, 47, 0.3)' 
                  }}
                >
                  पोस्टर बनाएं
                </Button>
              </Box>
            ) : (
              <Button 
                fullWidth 
                variant="contained" 
                component={Link} 
                to="/dashboard"
                sx={{ background: '#1E293B', borderRadius: '12px', py: 1.5, fontWeight: '800' }}
              >
                डैशबोर्ड खोलें
              </Button>
            )}
          </Box>
        </Box>
      </Drawer>
      
      <Toolbar sx={{ mb: 1 }} /> 
    </>
  );
}